import React from 'react';
import { Box, Chip, IconButton, Typography } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CircleIcon from '@mui/icons-material/Circle';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { getProfileSectionIcon } from '../CompanyProfile/sections/profileSectionIcons';

const SectionDefinitionCard = ({ definition, selected = false, onEdit, onDelete }) => {
  const locked = definition.role === 'additional_knowledge';
  const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({
    id: String(definition._id),
    disabled: locked,
  });
  const Icon = getProfileSectionIcon(definition.icon);
  const isActive = definition.active !== false;

  return (
    <Box
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.85 : isActive ? 1 : 0.62,
        zIndex: isDragging ? 2 : 0,
      }}
      border={selected ? 2 : 1}
      borderColor={selected ? 'primary.main' : 'divider'}
      borderRadius={2}
      p={1.5}
      minHeight={172}
      display='flex'
      flexDirection='column'
      bgcolor='#fff'
      position='relative'
    >
      <Box display='flex' alignItems='center' justifyContent='space-between' mb={0.5}>
        <IconButton
          size='small'
          aria-label='Reorder card'
          disabled={locked}
          {...attributes}
          {...listeners}
          sx={{ cursor: locked ? 'default' : 'grab', color: 'text.secondary' }}
        >
          <DragIndicatorIcon fontSize='small' />
        </IconButton>
        <Box display='flex' alignItems='center'>
          <IconButton size='small' aria-label='Edit card' onClick={() => onEdit(definition)}>
            <EditOutlinedIcon fontSize='small' />
          </IconButton>
          {!locked && (
            <IconButton
              size='small'
              aria-label='Delete card'
              onClick={(event) => {
                event.stopPropagation();
                onDelete(definition);
              }}
            >
              <DeleteOutlineIcon fontSize='small' />
            </IconButton>
          )}
        </Box>
      </Box>

      <Box flex={1} display='flex' flexDirection='column' alignItems='center' justifyContent='center' textAlign='center' px={1}>
        <Icon sx={{ fontSize: 44, color: isActive ? 'primary.main' : 'text.disabled', mb: 1.25 }} />
        <Typography variant='body2' fontWeight={600} sx={{ lineHeight: 1.3 }}>
          {definition.name}
        </Typography>
      </Box>

      <Box display='flex' alignItems='center' justifyContent='center' gap={0.75} mt={1}>
        {isActive ? (
          <>
            <CircleIcon sx={{ fontSize: 8, color: '#16a34a' }} />
            <Typography variant='caption' sx={{ color: '#16a34a', fontWeight: 600 }}>
              Active
            </Typography>
          </>
        ) : (
          <Chip label='Inactive' size='small' sx={{ height: 22, fontSize: 11, fontWeight: 600 }} />
        )}
      </Box>
    </Box>
  );
};

export default SectionDefinitionCard;
